<template>
<div class="chapter">
<div class="inner_page">
<h2 class="TOC-CH-T">Contents</h2>
<h2 class="TOC-FBMHD"><a href="#/int">Introduction</a></h2>
<h2 class="TOC-FBMHD"><a href="#/c01">Sugarpaste</a></h2>
<h2 class="TOC-FBMHD"><a href="#/c02">Modelling</a></h2>
<h2 class="TOC-FBMHD"><span href="#/c03" title="Link target outside of Sample">Recipes</span></h2>
<h2 class="TOC-FBMHD"><span href="#/c04" title="Link target outside of Sample">Covering Cakes</span></h2>
<h2 class="TOC-FBMHD"><span href="#/c05" title="Link target outside of Sample">Dowelling Cakes</span></h2>
<h2 class="TOC-FBMHD"><span href="#/c06" title="Link target outside of Sample">Have Your Cake and Eat It!</span></h2>
<h2 class="TOC-FBMHD"><span href="#/c07" title="Link target outside of Sample">Rock Your Socks Off</span></h2>
<h2 class="TOC-FBMHD"><span href="#/c08" title="Link target outside of Sample">Ladies' Night at the Pool</span></h2>
<h2 class="TOC-FBMHD"><span href="#/c09" title="Link target outside of Sample">Hot Stuff</span></h2>
<h2 class="TOC-FBMHD"><span href="#/c10" title="Link target outside of Sample">The Stripper!</span></h2>
<h2 class="TOC-FBMHD"><span href="#/c11" title="Link target outside of Sample">Honey of a Bunny Girl</span></h2>
<h2 class="TOC-FBMHD"><span href="#/c12" title="Link target outside of Sample">Bubble-icious</span></h2>
<h2 class="TOC-FBMHD"><span href="#/c13" title="Link target outside of Sample">Calendar Girls</span></h2>
<h2 class="TOC-FBMHD"><span href="#/c14" title="Link target outside of Sample">Suppliers</span></h2>
<h2 class="TOC-FBMHD"><span href="#/ata" title="Link target outside of Sample">About the Author</span></h2>
<h2 class="TOC-FBMHD"><span href="#/ack" title="Link target outside of Sample">Acknowledgments</span></h2>
<h2 class="TOC-FBMHD"><span href="#/cop" title="Link target outside of Sample">Copyright</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?9424e264